import css from './DetailLinksTable.css'